








import { Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    "content-header-control": () =>
      import("@/skeleton/admin/loggedIn/contentHeaderControl.vue")
  }
})
export default class ContentHeaderDocsControl extends Vue {
  // Methods
  public openDocsPreviwModal() {
    this.$store.dispatch("ui/openShowDocsPreviewModal", {
      props: {
        categorySlug: this.$route.meta?.categorySlug || null,
        docsSlugs: this.$route.meta?.docsSlugs || null,
        docsSearchQuery: this.$route.meta?.docsSearchQuery || null
      }
    });
  }
}
